"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.format = void 0;
exports.formatHEXA = formatHEXA;
exports.formatHEX = formatHEX;
exports.formatRGBA = formatRGBA;
exports.toRGBA = toRGBA;
exports.formatHSLA = formatHSLA;
exports.toHSLA = toHSLA;
exports.formatHWBA = formatHWBA;
exports.toHWBA = toHWBA;
const core = __importStar(require("./core"));
const {
  getRed,
  getGreen,
  getBlue,
  getAlpha
} = core;
// Return buffer, avoid allocations
const buffer = [0, 0, 0];
/**
 * Map 8-bits value to its hexadecimal representation
 * ['00', '01', '02', ..., 'fe', 'ff']
 */
const FORMAT_HEX = Array.from({
  length: 256
}).map((_, byte) => byte.toString(16).padStart(2, '0'));
/** Format to a #RRGGBBAA string */
exports.format = formatHEXA;
/** Format to a #RRGGBBAA string */
function formatHEXA(color) {
  return '#' + FORMAT_HEX[getRed(color)] + FORMAT_HEX[getGreen(color)] + FORMAT_HEX[getBlue(color)] + FORMAT_HEX[getAlpha(color)];
}
function formatHEX(color) {
  return '#' + FORMAT_HEX[getRed(color)] + FORMAT_HEX[getGreen(color)] + FORMAT_HEX[getBlue(color)];
}
function formatRGBA(color) {
  return `rgba(${getRed(color)} ${getGreen(color)} ${getBlue(color)} / ${getAlpha(color) / 255})`;
}
function toRGBA(color) {
  return {
    r: getRed(color),
    g: getGreen(color),
    b: getBlue(color),
    a: getAlpha(color)
  };
}
function formatHSLA(color) {
  rgbToHSL(getRed(color), getGreen(color), getBlue(color));
  const h = buffer[0];
  const s = buffer[1];
  const l = buffer[2];
  const a = getAlpha(color) / 255;
  return `hsla(${h} ${s}% ${l}% / ${a})`;
}
function toHSLA(color) {
  rgbToHSL(getRed(color), getGreen(color), getBlue(color));
  const h = buffer[0];
  const s = buffer[1];
  const l = buffer[2];
  const a = getAlpha(color) / 255;
  return {
    h,
    s,
    l,
    a
  };
}
function formatHWBA(color) {
  rgbToHWB(getRed(color), getGreen(color), getBlue(color));
  const h = buffer[0];
  const w = buffer[1];
  const b = buffer[2];
  const a = getAlpha(color) / 255;
  return `hsla(${h} ${w}% ${b}% / ${a})`;
}
function toHWBA(color) {
  rgbToHWB(getRed(color), getGreen(color), getBlue(color));
  const h = buffer[0];
  const w = buffer[1];
  const b = buffer[2];
  const a = getAlpha(color) / 255;
  return {
    h,
    w,
    b,
    a
  };
}
// Conversion functions
// https://www.30secondsofcode.org/js/s/rgb-hex-hsl-hsb-color-format-conversion/
function rgbToHSL(r, g, b) {
  r /= 255;
  g /= 255;
  b /= 255;
  const l = Math.max(r, g, b);
  const s = l - Math.min(r, g, b);
  const h = s ? l === r ? (g - b) / s : l === g ? 2 + (b - r) / s : 4 + (r - g) / s : 0;
  buffer[0] = 60 * h < 0 ? 60 * h + 360 : 60 * h;
  buffer[1] = 100 * (s ? l <= 0.5 ? s / (2 * l - s) : s / (2 - (2 * l - s)) : 0);
  buffer[2] = 100 * (2 * l - s) / 2;
}
// https://stackoverflow.com/a/29463581/3112706
function rgbToHWB(r, g, b) {
  r /= 255;
  g /= 255;
  b /= 255;
  const w = Math.min(r, g, b);
  const v = Math.max(r, g, b);
  const black = 1 - v;
  if (v === w) {
    buffer[0] = 0;
    buffer[1] = w;
    buffer[2] = black;
    return;
  }
  let f = r === w ? g - b : g === w ? b - r : r - g;
  let i = r === w ? 3 : g === w ? 5 : 1;
  buffer[0] = (i - f / (v - w)) / 6;
  buffer[1] = w;
  buffer[2] = black;
}
